import { createReducer } from '@reduxjs/toolkit';

import getUserDetails from '../../thunks/users/getUserDetails';

const initialState = {
  loading: false,
  error: null,
  user: undefined
};

const getUserDetailsReducer = createReducer(initialState, {
  [getUserDetails.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getUserDetails.fulfilled]: (state, { payload: user }) => ({
    ...state,
    loading: false,
    user
  }),
  [getUserDetails.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    user: undefined
  }),
});

export default getUserDetailsReducer;
